import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastPrimeService {
  private readonly messageService = inject(MessageService);

  showSuccess(message: string) {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      key: 'toast-prime-component',
      life: 3000,
      styleClass: 'custom-template success',
      data: {
        iconClass: 'ph ph-check-circle',
        color: ' #49D16F',
      },
    });
  }

  showInlineSuccess(message: string) {
    this.messageService.add({
      severity: 'success',
      summary: '',
      detail: message,
      key: 'toast-prime-component',
      life: 3000,
      styleClass: 'custom-template-inline success',
      data: {
        iconClass: 'ph ph-check-circle',
        color: '#49D16F',
      },
    });
  }

  showInfo(message: string) {
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: message,
      key: 'toast-prime-component',
      life: 3000,
      styleClass: 'custom-template info',
      data: {
        iconClass: 'ph ph-info',
        color: '#0085CA',
      },
    });
  }

  showInlineInfo(message: string) {
    this.messageService.add({
      severity: 'info',
      summary: '',
      detail: message,
      key: 'toast-prime-component',
      life: 3000,
      styleClass: 'custom-template-inline info',
      data: {
        iconClass: 'ph ph-info',
        color: '#0085CA',
      },
    });
  }

  showWarning(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: message,
      key: 'toast-prime-component',
      life: 10000,

      styleClass: 'custom-template warning',
      data: {
        iconClass: 'ph ph-warning',
        color: '#FF9900',
      },
    });
  }

  showInlineWarning(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: '',
      detail: message,
      key: 'toast-prime-component',
      life: 10000,
      styleClass: 'custom-template-inline warning',
      data: {
        iconClass: 'ph ph-warning',
        color: '#FF9900',
      },
    });
  }

  showErrorMessage(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      key: 'toast-prime-component',
      life: 3000,
      styleClass: 'custom-template error',
      data: {
        iconClass: 'ph ph-x-circle',
        color: '#F02B02',
      },
    });
  }

  showInlineErrorMessage(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: '',
      detail: message,
      key: 'toast-prime-component',
      life: 3000,
      styleClass: 'custom-template-inline error',
      data: {
        iconClass: 'ph ph-x-circle',
        color: '#F02B02',
      },
    });
  }

  showWarningInnerHTML(message: string, isSticky: boolean) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: message,
      key: 'toast-prime-component-innerHtml',
      life: 10000,
      sticky: isSticky,
      styleClass: 'custom-template warning',
      data: {
        iconClass: 'ph ph-warning',
        color: '#FF9900',
      },
    });
  }
}
